import api from "@/modules/api";

export async function getPeriodsByDomain(domain){
    return api.get(`/periods/${domain}?disabled=false`)
}